export const AdminPageType = {
  ADMIN: 'admin',
  STAFF: 'staff',
};
